var _defs, _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _image, _tspan6, _image2, _image3, _tspan7, _tspan8, _tspan9, _tspan10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategories2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "550.438 111.592 1283.22 149.568",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-About_us_10_categories"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1595.903,
    height: 1023.307
  })))), /*#__PURE__*/React.createElement("g", {
    id: "About_us_10_categories",
    "data-name": "About us_10 categories",
    className: "cls-1",
    style: {
      clipPath: "url(#clip-About_us_10_categories)"
    },
    transform: "matrix(1, 0, 0, 1, 234.98967, 83.826126)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.779263, 0, 0, 0.720198, 890.750305, -103.265213)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    id: "Line_357",
    "data-name": "Line 357",
    className: "cls-2",
    y2: 284.802,
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    },
    x1: 798.084,
    y1: 267.209,
    x2: 798.084
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_706",
    "data-name": "Rectangle 706",
    className: "cls-3",
    width: 142.036,
    height: 167.356,
    rx: 2.835,
    style: {
      fill: "none",
      stroke: "rgb(246, 247, 248)",
      strokeMiterlimit: 10,
      strokeWidth: "3.8px"
    },
    x: 747.552,
    y: 202.351
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\u05D3\\u05D9\\u05D5\\u05E8",
    className: "cls-4",
    transform: "matrix(0.56588, 0, 0, 0.621804, 779.023071, 330.113068)",
    style: {
      whiteSpace: "pre",
      fill: "rgb(53, 82, 121)",
      fontFamily: "AlmoniMLDemiBoldAAA-D-Bold, &quot",
      fontSize: 36,
      fontWeight: 700,
      letterSpacing: "-0.41px",
      lineHeight: "65.6px",
      perspectiveOrigin: "51.3594px 22.5px"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 105,
    y: 36
  }, "\u05D3\u05D9\u05D5\u05E8"))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2838",
    "data-name": "Path 2838",
    className: "cls-5",
    d: "M 853.77 312.809 L 842.961 299.77 C 841.373 297.859 838.89 297.195 836.68 298.091 L 833.44 293.768 L 842.239 285.809 C 845.579 282.786 844.701 276.925 840.654 275.239 L 815.519 264.758 C 811.462 263.067 807.261 266.836 807.957 271.542 C 807.96 271.559 807.962 271.576 807.965 271.594 L 812.509 300.711 C 812.837 302.892 814.209 304.71 816.099 305.468 C 816.732 305.729 817.403 305.863 818.079 305.865 C 819.382 305.863 820.643 305.361 821.644 304.445 L 830.442 296.486 L 833.678 300.804 C 832.456 303.017 832.575 305.823 833.978 307.903 L 843.551 322.062 C 844.628 323.667 846.261 324.711 848.063 324.945 C 848.336 324.982 848.61 325 848.884 325 C 853.986 324.989 857.164 318.913 854.604 314.064 C 854.367 313.616 854.087 313.196 853.77 312.813 L 853.77 312.809 Z",
    style: {
      fill: "rgb(157, 228, 198)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2839",
    "data-name": "Path 2839",
    className: "cls-2",
    d: "M 813.071 264.297 L 817.613 293.415 C 818.093 296.487 821.414 297.844 823.604 295.862 L 844.196 277.227 C 846.386 275.245 845.811 271.403 843.158 270.297 L 818.023 259.816 C 815.363 258.707 812.609 261.177 813.065 264.262 C 813.067 264.274 813.069 264.286 813.071 264.297 Z",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_354",
    "data-name": "Line 354",
    className: "cls-2",
    x2: 839.381,
    y2: 293.858,
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    },
    x1: 829.986,
    y1: 281.322
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2840",
    "data-name": "Path 2840",
    className: "cls-2",
    d: "M 839.378 293.86 L 839.384 293.854 C 840.98 292.41 843.326 292.595 844.718 294.273 L 855.527 307.312 C 857.329 309.486 857.109 312.875 855.042 314.745 L 855.033 314.754 C 852.967 316.625 849.895 316.214 848.299 313.852 L 838.725 299.693 C 837.493 297.868 837.78 295.303 839.378 293.86 Z",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2841",
    "data-name": "Path 2841",
    className: "cls-2",
    d: "M 792.708 249.616 L 792.708 232.023 L 844.434 232.023 L 844.434 249.616",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_355",
    "data-name": "Line 355",
    className: "cls-2",
    y2: 248.263,
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    },
    x1: 818.571,
    y1: 232.023,
    x2: 818.571
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2842",
    "data-name": "Path 2842",
    className: "cls-2",
    d: "M 806.255 249.573 L 806.255 267.208 L 780.394 267.208 L 780.394 249.615 L 856.752 249.615 L 856.752 267.208 L 849.363 267.208",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_356",
    "data-name": "Line 356",
    className: "cls-2",
    y2: 256.383,
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    },
    x1: 830.887,
    y1: 249.616,
    x2: 830.887
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2843",
    "data-name": "Path 2843",
    className: "cls-2",
    d: "M 808.718 284.801 L 780.392 284.801 L 780.392 302.394 L 811.182 302.394",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_358",
    "data-name": "Line 358",
    className: "cls-2",
    y2: 302.394,
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    },
    x1: 806.255,
    y1: 284.802,
    x2: 806.255
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_711",
    "data-name": "Rectangle 711",
    className: "cls-6",
    width: 11.188,
    height: 37.337,
    style: {
      fill: "rgb(183, 166, 219)"
    },
    x: 450.959,
    y: 264.505
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2844",
    "data-name": "Path 2844",
    className: "cls-2",
    d: "M 476.783 295.111 L 467.681 292.251 L 462.479 292.251",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2845",
    "data-name": "Path 2845",
    className: "cls-2",
    d: "M 462.479 263.675 L 467.68 263.675 L 481.984 260.815",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2846",
    "data-name": "Path 2846",
    className: "cls-2",
    d: "M 452.075 259.389 L 462.478 259.389 L 462.478 296.54 L 452.075 296.54",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_707",
    "data-name": "Rectangle 707",
    className: "cls-3",
    width: 142.036,
    height: 167.356,
    rx: 2.835,
    style: {
      fill: "none",
      stroke: "rgb(246, 247, 248)",
      strokeMiterlimit: 10,
      strokeWidth: "3.8px"
    },
    x: 421.584,
    y: 202.351
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\u05E9\\u05D9\\u05D9\\u05DB\\u05D5\\u05EA",
    className: "cls-4",
    transform: "matrix(0.56588, 0, 0, 0.621804, 453.055817, 330.113678)",
    style: {
      whiteSpace: "pre",
      fill: "rgb(53, 82, 121)",
      fontFamily: "AlmoniMLDemiBoldAAA-D-Bold, &quot",
      fontSize: 36,
      fontWeight: 700,
      letterSpacing: "-0.41px",
      lineHeight: "65.6px",
      perspectiveOrigin: "61.5px 22.5px"
    }
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 114,
    y: 36
  }, "\u05E9\u05D9\u05D9\u05DB\u05D5\u05EA"))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_708",
    "data-name": "Rectangle 708",
    className: "cls-6",
    width: 11.188,
    height: 37.152,
    style: {
      fill: "rgb(183, 166, 219)"
    },
    x: 523.059,
    y: 254.247
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_709",
    "data-name": "Rectangle 709",
    className: "cls-6",
    width: 12.294,
    height: 33.093,
    transform: "matrix(0, -1, 1, 0, 470.314026, 242.780685)",
    style: {
      fill: "rgb(183, 166, 219)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_710",
    "data-name": "Rectangle 710",
    className: "cls-6",
    width: 12.294,
    height: 29.554,
    transform: "matrix(0, -1, 1, 0, 483.050293, 322.750275)",
    style: {
      fill: "rgb(183, 166, 219)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2001",
    "data-name": "Group 2001",
    transform: "matrix(0.56588, 0, 0, 0.621804, -2821.484131, -2558.463623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2847",
    "data-name": "Path 2847",
    className: "cls-2",
    d: "M5881.415,4589.184l18.383-4.6h9.192",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2848",
    "data-name": "Path 2848",
    className: "cls-2",
    d: "M5908.99,4538.628H5899.8l-18.383-4.6",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2002",
    "data-name": "Group 2002",
    transform: "matrix(0.56588, 0, 0, 0.621804, -2821.484131, -2558.463623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2849",
    "data-name": "Path 2849",
    className: "cls-2",
    d: "M5927.374,4531.735H5908.99v59.747h18.383",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2004",
    "data-name": "Group 2004",
    transform: "matrix(0.56588, 0, 0, 0.621804, -2821.484131, -2558.463623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2850",
    "data-name": "Path 2850",
    className: "cls-2",
    d: "M5835.456,4506.458v9.191l-9.192,18.384",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2851",
    "data-name": "Path 2851",
    className: "cls-2",
    d: "M5876.819,4506.458v9.191l6.894,25.278",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2005",
    "data-name": "Group 2005",
    transform: "matrix(0.56588, 0, 0, 0.621804, -2821.484131, -2558.463623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2852",
    "data-name": "Path 2852",
    className: "cls-2",
    d: "M5883.713,4488.074v16.086h-55.151v-16.086",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2007",
    "data-name": "Group 2007",
    transform: "matrix(0.56588, 0, 0, 0.621804, -2821.484131, -2558.463623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2853",
    "data-name": "Path 2853",
    className: "cls-2",
    d: "M5837.754,4557.012v-26.426a5.762,5.762,0,0,1,5.745-5.745h0a5.762,5.762,0,0,1,5.745,5.745v-4.6a5.761,5.761,0,0,1,5.744-5.745h0a5.762,5.762,0,0,1,5.745,5.745v4.6a5.762,5.762,0,0,1,5.745-5.745h0a5.762,5.762,0,0,1,5.745,5.745v11.49a5.761,5.761,0,0,1,5.745-5.745h0a5.762,5.762,0,0,1,5.745,5.745v34.917a32.166,32.166,0,0,1-3.4,14.387l-5.795,11.591c-.159.319,0,11.49,0,11.49",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2854",
    "data-name": "Path 2854",
    className: "cls-2",
    d: "M5837.754,4614.461v-11.49l-9.394-15.03a13.791,13.791,0,0,1-2.1-7.308v-28.217a2.3,2.3,0,0,1,2.3-2.3h0a9.219,9.219,0,0,1,9.192,9.192v11.49",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2008",
    "data-name": "Group 2008",
    transform: "matrix(0.56588, 0, 0, 0.621804, -2821.484131, -2558.463623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2855",
    "data-name": "Path 2855",
    className: "cls-2",
    d: "M5830.86,4630.546v-16.085h50.555v16.085",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    id: "Line_369",
    "data-name": "Line 369",
    className: "cls-2",
    x2: 141.668,
    y2: 298.456,
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    },
    x1: 137.918,
    y1: 294.335
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_705",
    "data-name": "Rectangle 705",
    className: "cls-3",
    width: 142.036,
    height: 167.356,
    rx: 2.835,
    style: {
      fill: "none",
      stroke: "rgb(246, 247, 248)",
      strokeMiterlimit: 10,
      strokeWidth: "3.8px"
    },
    x: 96.239,
    y: 202.483
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\u05D3\\u05D9\\u05D5\\u05E8_\\u05DE\\u05DB\\u05D9\\u05DC",
    "data-name": "\\u05D3\\u05D9\\u05D5\\u05E8 \\u05DE\\u05DB\\u05D9\\u05DC",
    className: "cls-4",
    transform: "matrix(0.56588, 0, 0, 0.621804, 98.259193, 330.783356)",
    style: {
      whiteSpace: "pre",
      fill: "rgb(53, 82, 121)",
      fontFamily: "AlmoniMLDemiBoldAAA-D-Bold, &quot",
      fontSize: 36,
      fontWeight: 700,
      letterSpacing: "-0.41px",
      lineHeight: "65.6px",
      perspectiveOrigin: "99.7656px 22.5px"
    }
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 185,
    y: 36
  }, "\u05D3\u05D9\u05D5\u05E8 \u05DE\u05DB\u05DC\u05D9\u05DC"))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2874",
    "data-name": "Path 2874",
    className: "cls-13",
    d: "M 149.17 243.688 L 172.315 243.73 C 176.026 234.102 187.831 232.5 193.563 240.845 C 195.123 243.116 195.994 245.867 196.055 248.711 C 196.07 259.104 185.841 265.618 177.643 260.437 C 175.945 259.364 174.505 257.861 173.444 256.052 L 167.924 256.052 L 166.048 253.992 L 164.173 256.052 L 160.422 256.052 L 158.547 253.992 L 154.796 253.992 L 152.92 256.052 L 147.294 256.052 L 143.544 249.87 L 149.17 243.688 Z",
    style: {
      fill: "rgb(255, 159, 94)",
      stroke: "rgb(255, 159, 94)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2875",
    "data-name": "Path 2875",
    className: "cls-2",
    d: "M 156.672 304.708 C 157.39 303.92 158.126 302.718 160.423 302.718 L 186.68 302.718 C 188.764 302.718 200.226 290.017 201.683 288.221 C 203.084 286.495 209.328 276.15 211.06 271.7 C 209.973 270.091 207.033 268.735 203.558 269.621 C 200.243 270.468 198.293 273.076 196.057 277.855 L 188.469 282.318",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2876",
    "data-name": "Path 2876",
    className: "cls-2",
    d: "M 167.924 290.357 L 182.927 290.357 C 190.429 290.357 190.429 280.053 182.927 280.053 L 173.019 280.053 C 171.456 280.053 168.526 275.932 166.049 275.932 L 156.672 275.932 C 154.138 275.932 150.99 278.12 149.17 279.982 C 146.36 283.07 141.669 288.261 141.669 288.261",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_720",
    "data-name": "Rectangle 720",
    className: "cls-2",
    width: 13.932,
    height: 33.288,
    transform: "matrix(0.673066, -0.739583, 0.676057, 0.742869, 128.541122, 294.335083)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2877",
    "data-name": "Path 2877",
    className: "cls-2",
    d: "M 149.17 249.142 L 172.315 249.184 C 176.026 239.556 187.831 237.954 193.563 246.299 C 195.123 248.57 195.994 251.322 196.055 254.166 C 196.07 264.559 185.841 271.073 177.643 265.891 C 175.945 264.819 174.505 263.315 173.444 261.507 L 167.924 261.507 L 166.048 259.446 L 164.173 261.507 L 160.422 261.507 L 158.547 259.446 L 154.796 259.446 L 152.92 261.507 L 147.294 261.507 L 143.544 255.325 L 149.17 249.142 Z",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_370",
    "data-name": "Line 370",
    className: "cls-2",
    y2: 257.385,
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    },
    x1: 186.678,
    y1: 251.203,
    x2: 186.678
  })), /*#__PURE__*/React.createElement("g", {
    id: "about_us_2_category",
    "data-name": "about us #2 category",
    transform: "matrix(0.56588, 0, 0, 0.621804, 583.874268, 202.350998)",
    style: {}
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_718",
    "data-name": "Rectangle 718",
    className: "cls-3",
    width: 251.001,
    height: 269.146,
    rx: 2.835,
    transform: "translate(252.451 269.146) rotate(-180)",
    style: {
      fill: "none",
      stroke: "rgb(246, 247, 248)",
      strokeMiterlimit: 10,
      strokeWidth: "3.8px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\u05D0\\u05D9\\u05DB\\u05D5\\u05EA_\\u05D7\\u05D9\\u05D9\\u05DD",
    "data-name": "\\u05D0\\u05D9\\u05DB\\u05D5\\u05EA \\u05D7\\u05D9\\u05D9\\u05DD",
    className: "cls-4",
    transform: "translate(180 204.567)",
    style: {
      whiteSpace: "pre",
      fill: "rgb(53, 82, 121)",
      fontFamily: "AlmoniMLDemiBoldAAA-D-Bold, &quot",
      fontSize: 36,
      fontWeight: 700,
      letterSpacing: "-0.41px",
      lineHeight: "65.6px",
      perspectiveOrigin: "102.844px 22.5px"
    }
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 23,
    y: 36
  }, "\u05D0\u05D9\u05DB\u05D5\u05EA \u05D7\u05D9\u05D9\u05DD"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2016",
    "data-name": "Group 2016",
    transform: "translate(-6017.81 -4440.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2893",
    "data-name": "Path 2893",
    className: "cls-15",
    d: "M6156.055,4514.715s-17.49,13.526-17.49,30.211,17.49,30.21,17.49,30.21,17.49-13.525,17.49-30.21S6156.055,4514.715,6156.055,4514.715Z",
    style: {
      fill: "rgb(170, 221, 249)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2017",
    "data-name": "Group 2017",
    transform: "translate(-6017.81 -4440.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2894",
    "data-name": "Path 2894",
    className: "cls-2",
    d: "M6194.734,4632.542c-8.42-17.483-6-32.868-1.489-46.154,3.421-10.065,13.944-20.156,13.944-40.885s-18.324-49.972-61.3-50.882-54.77,31.165-56.893,41.175.91,16.381.741,18.909c-.26,3.9-10.111,16.718-11.595,19.01s-1.887,5.258,1.753,7.415,5.191,2.427,5.461,3.371c.173.606-.8,2.633-1.94,4.767a2.324,2.324,0,0,0,2.042,3.429l9.64,1.064",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2895",
    "data-name": "Path 2895",
    className: "cls-2",
    d: "M6127.5,4633.19c-1.934-8.029-6.259-14.289-9.349-17.02",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2896",
    "data-name": "Path 2896",
    className: "cls-2",
    d: "M6090.534,4598.76c-.625,5.528,3.534,6.019,3.756,10.146.089,1.666-1.118,7.263,5.022,9.6s21.02-3.047,25.125-4.352c1.2-.381,3.7-2.192,6.132-4.108",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2018",
    "data-name": "Group 2018",
    transform: "translate(-6017.81 -4440.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2897",
    "data-name": "Path 2897",
    className: "cls-2",
    d: "M6147.421,4516.715s-16.857,13.036-16.857,29.117,16.857,29.116,16.857,29.116,16.857-13.036,16.857-29.116S6147.421,4516.715,6147.421,4516.715Z",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2019",
    "data-name": "Group 2019",
    transform: "translate(-6017.81 -4440.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2898",
    "data-name": "Path 2898",
    className: "cls-2",
    d: "M6180.643,4541.755s-16.455-1.646-25.589,7.488-7.488,25.589-7.488,25.589,16.455,1.646,25.589-7.488S6180.643,4541.755,6180.643,4541.755Z",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2020",
    "data-name": "Group 2020",
    transform: "translate(-6017.81 -4440.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2899",
    "data-name": "Path 2899",
    className: "cls-2",
    d: "M6114.229,4541.914s16.613-1.805,25.748,7.329,7.329,25.748,7.329,25.748-16.614,1.8-25.748-7.329S6114.229,4541.914,6114.229,4541.914Z",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2021",
    "data-name": "Group 2021",
    transform: "matrix(0.56588, 0, 0, 0.621804, -2821.483887, -2558.46167)",
    style: {}
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_371",
    "data-name": "Line 371",
    className: "cls-2",
    x1: 12.259,
    transform: "translate(6067.576 4506.979)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_372",
    "data-name": "Line 372",
    className: "cls-2",
    y2: 12.259,
    transform: "translate(6073.705 4500.849)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_373",
    "data-name": "Line 373",
    className: "cls-2",
    x1: 12.259,
    transform: "translate(6082.84 4489.571)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_374",
    "data-name": "Line 374",
    className: "cls-2",
    y2: 12.259,
    transform: "translate(6088.97 4483.441)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    id: "Line_376",
    "data-name": "Line 376",
    className: "cls-2",
    x1: 307.517,
    y1: 269.506,
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    },
    x2: 301.056,
    y2: 265.695
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_377",
    "data-name": "Line 377",
    className: "cls-2",
    y1: 289.656,
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    },
    x1: 307.509,
    x2: 307.509,
    y2: 251.334
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2906",
    "data-name": "Path 2906",
    className: "cls-2",
    d: "M 312.024 254.764 L 307.509 257.853 L 302.524 254.764",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_378",
    "data-name": "Line 378",
    className: "cls-2",
    y1: 269.506,
    x2: 314.473,
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    },
    x1: 307.517,
    y2: 266.149
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\u05DE\\u05E8\\u05D7\\u05D1_\\u05E2\\u05D9\\u05E8\\u05D5\\u05E0\\u05D9",
    "data-name": "\\u05DE\\u05E8\\u05D7\\u05D1 \\u05E2\\u05D9\\u05E8\\u05D5\\u05E0\\u05D9",
    className: "cls-16",
    transform: "matrix(0.56588, 0, 0, 0.621804, 259.752319, 330.221893)",
    style: {
      whiteSpace: "pre",
      fill: "rgb(53, 82, 121)",
      fontFamily: "AlmoniMLDemiBoldAAA-D-Bold, &quot",
      fontSize: 36,
      fontWeight: 700,
      letterSpacing: "-0.41154px",
      lineHeight: "65.8464px",
      perspectiveOrigin: "107.016px 22.5px"
    }
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 206,
    y: 36
  }, "\u05DE\u05E8\u05D7\u05D1 \u05E2\u05D9\u05E8\u05D5\u05E0\u05D9"))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_721",
    "data-name": "Rectangle 721",
    className: "cls-3",
    width: 142.036,
    height: 167.356,
    rx: 2.835,
    style: {
      fill: "none",
      stroke: "rgb(246, 247, 248)",
      strokeMiterlimit: 10,
      strokeWidth: "3.8px"
    },
    x: 259.4,
    y: 202.483
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2900",
    "data-name": "Path 2900",
    className: "cls-17",
    d: "M 376.49 293.916 L 329.919 320.85 L 284.272 295.595 L 330.663 269.096 L 376.49 293.916 Z",
    style: {
      fill: "rgb(205, 230, 105)"
    }
  }), _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_722",
    "data-name": "Rectangle 722",
    width: 168.72,
    height: 89.04,
    transform: "matrix(0.56588, 0, 0, 0.621804, 282.669312, 261.789246)",
    href: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_375",
    "data-name": "Line 375",
    className: "cls-2",
    y1: 282.766,
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    },
    x1: 352.336,
    x2: 352.336,
    y2: 241.351
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2901",
    "data-name": "Path 2901",
    className: "cls-18",
    d: "M 362.648 243.091 L 360.486 243.091 L 358.731 246.031 L 358.731 246.102 L 364.4 246.102 L 364.4 246.031 L 362.646 243.091 L 362.648 243.091 Z",
    style: {
      fill: "rgb(53, 82, 121)",
      fillRule: "evenodd",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2902",
    "data-name": "Path 2902",
    className: "cls-19",
    d: "M 352.336 241.351 C 352.336 237.241 354.382 233.91 356.905 233.91 C 359.429 233.91 361.473 237.241 361.473 241.351",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2903",
    "data-name": "Path 2903",
    className: "cls-19",
    d: "M 352.336 241.351 C 352.336 237.241 350.291 233.91 347.769 233.91 C 345.246 233.91 343.2 237.241 343.2 241.351",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2904",
    "data-name": "Path 2904",
    className: "cls-18",
    d: "M 344.282 243.091 L 342.119 243.091 L 340.365 246.031 L 340.365 246.102 L 346.034 246.102 L 346.034 246.031 L 344.282 243.091 Z",
    style: {
      fill: "rgb(53, 82, 121)",
      fillRule: "evenodd",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2905",
    "data-name": "Path 2905",
    className: "cls-2",
    d: "M 316.434 258.209 C 319.882 255.486 319.354 249.683 315.484 247.764 C 314.091 247.074 312.5 247.049 311.09 247.696 C 312.427 243.775 309.4 239.734 305.642 240.422 C 301.924 241.103 300.235 245.918 302.575 249.164 C 302.423 249.153 302.271 249.139 302.116 249.139 C 297.153 249.139 294.052 255.042 296.533 259.764 C 296.835 260.34 297.21 260.866 297.645 261.326 C 291.659 263.857 290.41 272.56 295.398 276.992 C 296.882 278.31 298.732 279.029 300.64 279.028 C 303.839 279.028 306.113 277.046 307.51 274.14 C 309.319 275.894 311.65 276.86 314.062 276.856 C 320.723 276.857 324.886 268.934 321.556 262.596 C 320.433 260.457 318.596 258.883 316.435 258.206 L 316.434 258.209 Z",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2022",
    "data-name": "Group 2022",
    transform: "matrix(0.56588, 0, 0, 0.621804, -2820.351807, -2558.463379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2907",
    "data-name": "Path 2907",
    className: "cls-20",
    d: "M5582.4,4570.545h-28.843a1.367,1.367,0,0,1,0-2.735H5582.4a1.367,1.367,0,0,1,0,2.735Z",
    style: {
      fill: "rgb(53, 82, 121)",
      stroke: "rgb(53, 82, 121)",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2023",
    "data-name": "Group 2023",
    transform: "matrix(0.56588, 0, 0, 0.621804, -2820.351807, -2558.463379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2908",
    "data-name": "Path 2908",
    className: "cls-20",
    d: "M5546.348,4595.951a1.368,1.368,0,0,1-1.114-2.159l18.027-25.406a1.367,1.367,0,1,1,2.229,1.583l-18.026,25.406A1.366,1.366,0,0,1,5546.348,4595.951Z",
    style: {
      fill: "rgb(53, 82, 121)",
      stroke: "rgb(53, 82, 121)",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2024",
    "data-name": "Group 2024",
    transform: "matrix(0.56588, 0, 0, 0.621804, -2820.351807, -2558.463379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2909",
    "data-name": "Path 2909",
    className: "cls-20",
    d: "M5589.611,4595.951a1.365,1.365,0,0,1-1.116-.576l-18.027-25.406a1.368,1.368,0,0,1,2.23-1.583l18.027,25.406a1.368,1.368,0,0,1-1.114,2.159Z",
    style: {
      fill: "rgb(53, 82, 121)",
      stroke: "rgb(53, 82, 121)",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2025",
    "data-name": "Group 2025",
    transform: "matrix(0.56588, 0, 0, 0.621804, -2820.351807, -2558.463379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2910",
    "data-name": "Path 2910",
    className: "cls-20",
    d: "M5593.214,4581.53h-50.469a1.367,1.367,0,1,1,0-2.734h50.469a1.367,1.367,0,1,1,0,2.734Z",
    style: {
      fill: "rgb(53, 82, 121)",
      stroke: "rgb(53, 82, 121)",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.779446, 0, 0, 0.711482, 256.045013, -235.429352)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    id: "about_us_7_category",
    "data-name": "about us #7 category",
    transform: "matrix(0.56588, 0, 0, 0.621804, 583.874268, 392.535828)",
    style: {}
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_713",
    "data-name": "Rectangle 713",
    className: "cls-3",
    width: 251.001,
    height: 268.884,
    rx: 2.835,
    style: {
      fill: "none",
      stroke: "rgb(246, 247, 248)",
      strokeMiterlimit: 10,
      strokeWidth: "3.8px"
    },
    transform: "translate(1.449)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\u05DE\\u05E0\\u05D9\\u05E2\\u05EA_\\u05D3\\u05D7\\u05D9\\u05E7\\u05D4",
    "data-name": "\\u05DE\\u05E0\\u05D9\\u05E2\\u05EA \\u05D3\\u05D7\\u05D9\\u05E7\\u05D4",
    className: "cls-4",
    transform: "translate(0 205.471)",
    style: {
      whiteSpace: "pre",
      fill: "rgb(53, 82, 121)",
      fontFamily: "AlmoniMLDemiBoldAAA-D-Bold, &quot",
      fontSize: 36,
      fontWeight: 700,
      letterSpacing: "-0.41px",
      lineHeight: "65.6px",
      perspectiveOrigin: "108.141px 22.5px"
    }
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 209,
    y: 36
  }, "\u05DE\u05E0\u05D9\u05E2\u05EA \u05D3\u05D7\u05D9\u05E7\u05D4"))), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_714",
    "data-name": "Rectangle 714",
    width: 123.12,
    height: 59.52,
    transform: "translate(66.923 81.239)",
    href: "data:image/png;base64,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"
  })), _image3 || (_image3 = /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_715",
    "data-name": "Rectangle 715",
    width: 128.88,
    height: 85.44,
    transform: "translate(63.803 69.718)",
    href: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2856",
    "data-name": "Path 2856",
    className: "cls-2",
    d: "M5791.779,4919.166l18.884-6.295a13.745,13.745,0,0,1,5.224-1.045,14.7,14.7,0,0,1,4.018.589l32.144,9.537a14.717,14.717,0,0,0,4.018.589,13.419,13.419,0,0,0,7.5-2.277l52.878-31.528c-2.3-4.578-3.8-9.054-9.483-9.054a7.226,7.226,0,0,0-3.054.6l-24,9.6",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    },
    transform: "translate(-5729.568 -4728.199)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2857",
    "data-name": "Path 2857",
    className: "cls-2",
    d: "M5792.073,4885.736l28.046-7.849a23.392,23.392,0,0,1,6.483-.884,23.775,23.775,0,0,1,7.848,1.313l18.938,6.723h20.091a6.709,6.709,0,0,1,6.428,4.849,6.03,6.03,0,0,1,.268,1.848,6.7,6.7,0,0,1-6.7,6.7H5840",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    },
    transform: "translate(-5729.568 -4728.199)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2010",
    "data-name": "Group 2010",
    transform: "translate(-5729.568 -4728.199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2858",
    "data-name": "Path 2858",
    className: "cls-2",
    d: "M5921.258,4775.619l-18.885,6.295a13.749,13.749,0,0,1-5.223,1.044,14.711,14.711,0,0,1-4.018-.589l-32.144-9.536a14.7,14.7,0,0,0-4.018-.589,13.422,13.422,0,0,0-7.5,2.276l-52.877,31.529c2.3,4.578,3.8,9.054,9.483,9.054a7.234,7.234,0,0,0,3.053-.6l24-9.6",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2859",
    "data-name": "Path 2859",
    className: "cls-2",
    d: "M5920.963,4809.049l-28.045,7.848a23.376,23.376,0,0,1-6.483.884,23.774,23.774,0,0,1-7.848-1.312l-18.939-6.724h-20.09a6.71,6.71,0,0,1-6.429-4.848,6.074,6.074,0,0,1-.267-1.849,6.7,6.7,0,0,1,6.7-6.7h33.484",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "about_us_6_category",
    "data-name": "about us #6 category",
    transform: "matrix(0.56588, 0, 0, 0.621804, 746.731689, 392.372894)",
    style: {}
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_712",
    "data-name": "Rectangle 712",
    className: "cls-3",
    width: 251.001,
    height: 269.146,
    rx: 2.835,
    style: {
      fill: "none",
      stroke: "rgb(246, 247, 248)",
      strokeMiterlimit: 10,
      strokeWidth: "3.8px"
    },
    transform: "translate(1.449)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\u05E7\\u05D4\\u05D9\\u05DC\\u05D4",
    className: "cls-4",
    transform: "translate(0 205.472)",
    style: {
      whiteSpace: "pre",
      fill: "rgb(53, 82, 121)",
      fontFamily: "AlmoniMLDemiBoldAAA-D-Bold, &quot",
      fontSize: 36,
      fontWeight: 700,
      letterSpacing: "-0.41px",
      lineHeight: "65.6px",
      perspectiveOrigin: "84.3438px 22.5px"
    }
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 167,
    y: 36
  }, "\u05E7\u05D4\u05D9\u05DC\u05D4"))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_111",
    "data-name": "Ellipse 111",
    className: "cls-7",
    cx: 41.626,
    cy: 41.626,
    r: 41.626,
    transform: "translate(77.028 57.331)",
    style: {
      fill: "rgb(255, 229, 95)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2860",
    "data-name": "Path 2860",
    className: "cls-2",
    d: "M6178.391,4841.59a41.344,41.344,0,1,0-12.146,12.149l18.825,6.676Z",
    transform: "translate(-6016.81 -4727.937)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2011",
    "data-name": "Group 2011",
    transform: "translate(-6016.81 -4727.937)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2861",
    "data-name": "Path 2861",
    className: "cls-2",
    d: "M6157.519,4871.333a41.289,41.289,0,0,1-62.336,23.717l-18.825,6.676,6.68-18.83a41.253,41.253,0,0,1,6.958-53.153",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2862",
    "data-name": "Path 2862",
    className: "cls-2",
    d: "M6102.548,4821.994a46.558,46.558,0,0,1,15.121-2.89c21.53,0,39.227,15.854,41.132,38.467",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2012",
    "data-name": "Group 2012",
    transform: "translate(-6016.81 -4727.937)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2863",
    "data-name": "Path 2863",
    className: "cls-2",
    d: "M6169.851,4829.975a43.249,43.249,0,0,0-19.747,4.855",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2864",
    "data-name": "Path 2864",
    className: "cls-2",
    d: "M6146.622,4905.452a41.268,41.268,0,0,0,45.714.469l18.825,6.676-6.679-18.829a41.106,41.106,0,0,0,6.679-22.482,41.66,41.66,0,0,0-28.169-39.256",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2865",
    "data-name": "Path 2865",
    className: "cls-2",
    d: "M6139.906,4842.826a41.193,41.193,0,0,0-11.366,28.46,41.76,41.76,0,0,0,8.781,25.473",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "about_us_10_category",
    "data-name": "about us #10 category",
    transform: "matrix(0.56588, 0, 0, 0.621804, 96.646431, 392.372894)",
    style: {}
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\u05DB\\u05DC\\u05DB\\u05DC\\u05D4_\\u05DE\\u05E7\\u05D5\\u05DE\\u05D9\\u05EA",
    "data-name": "\\u05DB\\u05DC\\u05DB\\u05DC\\u05D4 \\u05DE\\u05E7\\u05D5\\u05DE\\u05D9\\u05EA",
    className: "cls-4",
    transform: "translate(0.352 206.336)",
    style: {
      whiteSpace: "pre",
      fill: "rgb(53, 82, 121)",
      fontFamily: "AlmoniMLDemiBoldAAA-D-Bold, &quot",
      fontSize: 36,
      fontWeight: 700,
      letterSpacing: "-0.41px",
      lineHeight: "65.6px",
      perspectiveOrigin: "112.203px 22.5px"
    }
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 217,
    y: 36
  }, "\u05DB\u05DC\u05DB\u05DC\u05D4 \u05DE\u05E7\u05D5\u05DE\u05D9\u05EA"))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_716",
    "data-name": "Rectangle 716",
    className: "cls-3",
    width: 251.001,
    height: 269.146,
    rx: 2.835,
    style: {
      fill: "none",
      stroke: "rgb(246, 247, 248)",
      strokeMiterlimit: 10,
      strokeWidth: "3.8px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_359",
    "data-name": "Line 359",
    className: "cls-2",
    x1: 140.705,
    transform: "translate(55.148 188.963)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2014",
    "data-name": "Group 2014",
    transform: "translate(-6018.259 -5016.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2866",
    "data-name": "Path 2866",
    className: "cls-8",
    d: "M6077.1,5124.142V5141.2a30.452,30.452,0,0,1,40.877,13.644A13.635,13.635,0,0,0,6131.6,5141.2l-8.183,12.572a11.213,11.213,0,1,1,21.947,1.072,13.626,13.626,0,1,1,27.251,0,13.626,13.626,0,1,1,27.251,0,13.634,13.634,0,0,0,13.625-13.644v-17.055Z",
    style: {
      fill: "rgb(180, 190, 195)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_719",
    "data-name": "Rectangle 719",
    className: "cls-2",
    width: 79.456,
    height: 14.07,
    transform: "translate(6105.602 5081.536)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_360",
    "data-name": "Line 360",
    className: "cls-2",
    y1: 51.165,
    transform: "translate(6145.239 5150.828)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_361",
    "data-name": "Line 361",
    className: "cls-2",
    y1: 51.165,
    transform: "translate(6201.364 5150.828)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_362",
    "data-name": "Line 362",
    className: "cls-2",
    y1: 51.165,
    transform: "translate(6088.119 5150.828)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_363",
    "data-name": "Line 363",
    className: "cls-2",
    y1: 9.806,
    transform: "translate(6134.197 5167.354)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_364",
    "data-name": "Line 364",
    className: "cls-2",
    y1: 28.077,
    x2: 27.697,
    transform: "translate(6160.106 5157.089)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_365",
    "data-name": "Line 365",
    className: "cls-2",
    y1: 18.994,
    x2: 18.736,
    transform: "translate(6169.884 5173.912)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2867",
    "data-name": "Path 2867",
    className: "cls-9",
    d: "M6213.42,5117.637v17.055a30.452,30.452,0,0,0-40.877,13.644,13.625,13.625,0,1,0-27.25,0,11.213,11.213,0,1,0-21.947-1.072",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2868",
    "data-name": "Path 2868",
    className: "cls-2",
    d: "M6077.166,5117.637v17.055a30.45,30.45,0,0,1,40.876,13.644,13.634,13.634,0,0,0,13.625-13.644",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_366",
    "data-name": "Line 366",
    className: "cls-9",
    y2: 3.672,
    transform: "translate(6186.169 5132.325)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_367",
    "data-name": "Line 367",
    className: "cls-9",
    y2: 3.672,
    transform: "translate(6158.918 5132.325)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_368",
    "data-name": "Line 368",
    className: "cls-9",
    y2: 3.672,
    transform: "translate(6131.667 5132.325)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2869",
    "data-name": "Path 2869",
    className: "cls-2",
    d: "M6106.4,5117.637h-29.236v-3.672l28.357-18.359h79.54l28.357,18.359v3.672H6101.175",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2013",
    "data-name": "Group 2013"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2870",
    "data-name": "Path 2870",
    className: "cls-10",
    d: "M6074.049,5172.922c-.011-.241-.019-.481-.019-.719a15.35,15.35,0,0,1,30.7,0c0,.238-.007.478-.018.717l-.01.181c-.611,10.968-11.938,25.125-15.321,29.123-3.383-4-14.711-18.158-15.323-29.147Z",
    style: {
      fill: "none",
      stroke: "rgb(255, 255, 255)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.364px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2871",
    "data-name": "Path 2871",
    className: "cls-11",
    d: "M6074.049,5172.922c-.011-.241-.019-.481-.019-.719a15.35,15.35,0,0,1,30.7,0c0,.238-.007.478-.018.717l-.01.181c-.611,10.968-11.938,25.125-15.321,29.123-3.383-4-14.711-18.158-15.323-29.147Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2872",
    "data-name": "Path 2872",
    className: "cls-2",
    d: "M6074.049,5172.922c-.011-.241-.019-.481-.019-.719a15.35,15.35,0,0,1,30.7,0c0,.238-.007.478-.018.717l-.01.181c-.611,10.968-11.938,25.125-15.321,29.123-3.383-4-14.711-18.158-15.323-29.147Z",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2873",
    "data-name": "Path 2873",
    className: "cls-12",
    d: "M6084.27,5169.726a4.6,4.6,0,1,1,4.6,4.6A4.61,4.61,0,0,1,6084.27,5169.726Z",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "4.4px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "about_us_8_category",
    "data-name": "about us #8 category",
    transform: "matrix(0.56588, 0, 0, 0.621804, 421.287292, 392.372894)",
    style: {}
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_717",
    "data-name": "Rectangle 717",
    className: "cls-3",
    width: 251.001,
    height: 268.884,
    rx: 2.835,
    style: {
      fill: "none",
      stroke: "rgb(246, 247, 248)",
      strokeMiterlimit: 10,
      strokeWidth: "3.8px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\u05EA\\u05DE\\u05D4\\u05D9\\u05DC_\\u05D7\\u05D1\\u05E8\\u05EA\\u05D9",
    "data-name": "\\u05EA\\u05DE\\u05D4\\u05D9\\u05DC \\u05D7\\u05D1\\u05E8\\u05EA\\u05D9",
    className: "cls-4",
    transform: "translate(0.521 204.633)",
    style: {
      whiteSpace: "pre",
      fill: "rgb(53, 82, 121)",
      fontFamily: "AlmoniMLDemiBoldAAA-D-Bold, &quot",
      fontSize: 36,
      fontWeight: 700,
      letterSpacing: "-0.41px",
      lineHeight: "65.6px",
      perspectiveOrigin: "109.109px 22.5px"
    }
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 210,
    y: 36
  }, "\u05EA\u05DE\u05D4\u05D9\u05DC \u05D7\u05D1\u05E8\u05EA\u05D9"))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2878",
    "data-name": "Path 2878",
    className: "cls-14",
    d: "M5537.037,4811.206c5.717,0,9.812-4.579,9.812-11.214v-2.8c0-6.635-4.1-11.214-9.812-11.214s-9.813,4.579-9.813,11.214v2.8C5527.224,4806.627,5531.319,4811.206,5537.037,4811.206Z",
    transform: "translate(-5442.752 -4728.199)",
    style: {
      fill: "rgb(239, 190, 221)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2879",
    "data-name": "Path 2879",
    className: "cls-14",
    d: "M5596.026,4798.425c5.717,0,9.812-4.578,9.812-11.214v-2.8c0-6.635-4.095-11.214-9.812-11.214s-9.813,4.579-9.813,11.214v2.8C5586.213,4793.847,5590.308,4798.425,5596.026,4798.425Z",
    transform: "translate(-5442.752 -4728.199)",
    style: {
      fill: "rgb(239, 190, 221)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2880",
    "data-name": "Path 2880",
    className: "cls-14",
    d: "M5523.074,4881.573c5.718,0,9.813-4.579,9.813-11.214v-2.8c0-6.635-4.1-11.214-9.813-11.214s-9.812,4.579-9.812,11.214v2.8C5513.262,4876.994,5517.357,4881.573,5523.074,4881.573Z",
    transform: "translate(-5442.752 -4728.199)",
    style: {
      fill: "rgb(239, 190, 221)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2881",
    "data-name": "Path 2881",
    className: "cls-14",
    d: "M5562.269,4888.977c5.718,0,9.813-4.579,9.813-11.214v-2.8c0-6.635-4.1-11.214-9.813-11.214s-9.812,4.579-9.812,11.214v2.8C5552.457,4884.4,5556.552,4888.977,5562.269,4888.977Z",
    transform: "translate(-5442.752 -4728.199)",
    style: {
      fill: "rgb(239, 190, 221)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2882",
    "data-name": "Path 2882",
    className: "cls-14",
    d: "M5587.5,4860.941c5.718,0,9.813-4.579,9.813-11.215v-2.8c0-6.636-4.095-11.215-9.813-11.215s-9.813,4.579-9.813,11.215v2.8C5577.689,4856.362,5581.784,4860.941,5587.5,4860.941Z",
    transform: "translate(-5442.752 -4728.199)",
    style: {
      fill: "rgb(239, 190, 221)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2015",
    "data-name": "Group 2015",
    transform: "translate(-5442.752 -4728.199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2883",
    "data-name": "Path 2883",
    className: "cls-2",
    d: "M5539.357,4819.886c5.718,0,9.813-4.579,9.813-11.215v-2.8c0-6.636-4.095-11.215-9.813-11.215s-9.813,4.579-9.813,11.215v2.8C5529.544,4815.307,5533.64,4819.886,5539.357,4819.886Z",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2884",
    "data-name": "Path 2884",
    className: "cls-2",
    d: "M5598.346,4807.1c5.718,0,9.813-4.579,9.813-11.215v-2.8c0-6.636-4.1-11.215-9.813-11.215s-9.813,4.579-9.813,11.215v2.8C5588.533,4802.526,5592.629,4807.1,5598.346,4807.1Z",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2885",
    "data-name": "Path 2885",
    className: "cls-2",
    d: "M5525.4,4890.253c5.717,0,9.813-4.579,9.813-11.215v-2.8c0-6.635-4.1-11.214-9.813-11.214s-9.813,4.579-9.813,11.214v2.8C5515.582,4885.674,5519.677,4890.253,5525.4,4890.253Z",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2886",
    "data-name": "Path 2886",
    className: "cls-2",
    d: "M5554.777,4853.529v-11.214l14.018-14.018,7.811-14.2c1.786-4.465-.86-10.743-5.119-13.839,0,0-9.262,14.018-11.1,16.822s-5.824,11.215-16.821,11.215h-8.411c-11,0-18.666-14.019-16.822-11.215s-11.1-16.822-11.1-16.822c-4.259,3.1-6.9,9.374-5.118,13.839l7.81,14.2,14.018,14.018v2.8",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2887",
    "data-name": "Path 2887",
    className: "cls-2",
    d: "M5612.568,4840.2v-11.214l14.019-14.019,7.81-14.2c1.786-4.465-.86-10.743-5.118-13.839l-11.1,16.822s-5.824,11.214-16.822,11.214h-11.215",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2888",
    "data-name": "Path 2888",
    className: "cls-2",
    d: "M5507.227,4914.478v-5.607c0-9.261,10.805-11.214,18.168-11.214s18.168,1.953,18.168,11.214v5.607",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2889",
    "data-name": "Path 2889",
    className: "cls-2",
    d: "M5554.769,4907.1a43.368,43.368,0,0,1,9.877-1.032c7.362,0,18.167,1.465,18.167,8.411",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2890",
    "data-name": "Path 2890",
    className: "cls-2",
    d: "M5564.59,4897.657c5.717,0,9.813-4.579,9.813-11.215v-2.8c0-6.635-4.1-11.214-9.813-11.214s-9.813,4.579-9.813,11.214v2.8C5554.777,4893.078,5558.872,4897.657,5564.59,4897.657Z",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2891",
    "data-name": "Path 2891",
    className: "cls-2",
    d: "M5589.822,4869.62c5.718,0,9.813-4.579,9.813-11.214v-2.8c0-6.635-4.095-11.214-9.813-11.214s-9.812,4.579-9.812,11.214v2.8C5580.01,4865.041,5584.1,4869.62,5589.822,4869.62Z",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2892",
    "data-name": "Path 2892",
    className: "cls-2",
    d: "M5605.242,4903.264v-11.215l14.019-14.018,7.81-14.2c1.786-4.466-.86-10.743-5.118-13.839l-11.1,16.822s-5.824,11.214-16.822,11.214h-11.215",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "about_us_9_category",
    "data-name": "about us #9 category",
    transform: "matrix(0.56588, 0, 0, 0.621804, 257.863953, 392.372894)",
    style: {}
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2917",
    "data-name": "Path 2917",
    className: "cls-21",
    d: "M6389.968,5099.94h-12.054l-23.437,23.438h12.054Z",
    transform: "translate(-6306.302 -5016.391)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_397",
    "data-name": "Line 397",
    className: "cls-21",
    x2: 12.054,
    transform: "translate(63.577 91.585)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_398",
    "data-name": "Line 398",
    className: "cls-21",
    x2: 12.054,
    transform: "translate(55.542 99.621)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_400",
    "data-name": "Line 400",
    className: "cls-22",
    y1: 16.459,
    transform: "translate(66.906 100.26)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.57px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_31687",
    "data-name": "Group 31687",
    transform: "translate(-957.342 -655.734)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\u05D1\\u05E0\\u05D9\\u05D4_\\u05D9\\u05E8\\u05D5\\u05E7\\u05D4",
    "data-name": "\\u05D1\\u05E0\\u05D9\\u05D4 \\u05D9\\u05E8\\u05D5\\u05E7\\u05D4",
    className: "cls-4",
    transform: "translate(957.342 862.072)",
    style: {
      whiteSpace: "pre",
      fill: "rgb(53, 82, 121)",
      fontFamily: "AlmoniMLDemiBoldAAA-D-Bold, &quot",
      fontSize: 36,
      fontWeight: 700,
      letterSpacing: "-0.41px",
      lineHeight: "65.6px",
      perspectiveOrigin: "102.141px 22.5px"
    }
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 193,
    y: 36
  }, "\u05D1\u05E0\u05D9\u05D4 \u05D9\u05E8\u05D5\u05E7\u05D4"))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_723",
    "data-name": "Rectangle 723",
    className: "cls-3",
    width: 251.001,
    height: 269.146,
    rx: 2.835,
    transform: "translate(958.791 655.734)",
    style: {
      fill: "none",
      stroke: "rgb(246, 247, 248)",
      strokeMiterlimit: 10,
      strokeWidth: "3.8px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2027",
    "data-name": "Group 2027",
    transform: "translate(-5348.96 -4360.657)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2911",
    "data-name": "Path 2911",
    className: "cls-23",
    d: "M6492.559,5108.426S6518,5147.8,6518,5161.849a25.439,25.439,0,1,1-50.879,0C6467.119,5147.8,6492.559,5108.426,6492.559,5108.426Z",
    style: {
      fill: "rgb(113, 188, 111)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2026",
    "data-name": "Group 2026"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2912",
    "data-name": "Path 2912",
    className: "cls-22",
    d: "M6484.556,5110.205S6510,5149.578,6510,5163.628a25.439,25.439,0,0,1-50.879,0C6459.116,5149.578,6484.556,5110.205,6484.556,5110.205Z",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.57px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_379",
    "data-name": "Line 379",
    className: "cls-22",
    y2: 63.599,
    transform: "translate(6484.556 5140.732)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.57px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_380",
    "data-name": "Line 380",
    className: "cls-22",
    x2: 12.72,
    y2: 12.72,
    transform: "translate(6471.836 5161.083)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.57px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_381",
    "data-name": "Line 381",
    className: "cls-22",
    x1: 10.176,
    y2: 10.176,
    transform: "translate(6484.556 5150.908)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.57px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2913",
    "data-name": "Path 2913",
    className: "cls-22",
    d: "M6401.333,5205.047V5095.8h60.527v37.332",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.57px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_382",
    "data-name": "Line 382",
    className: "cls-22",
    y2: 14.395,
    transform: "translate(6461.86 5190.652)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.57px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_383",
    "data-name": "Line 383",
    className: "cls-24",
    x2: 33.045,
    transform: "translate(6415.358 5111.304)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeDasharray: "1.288px, 15.021px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.57px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_384",
    "data-name": "Line 384",
    className: "cls-24",
    x2: 33.045,
    transform: "translate(6415.358 5122.622)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeDasharray: "1.288px, 15.021px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.57px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_385",
    "data-name": "Line 385",
    className: "cls-24",
    x2: 33.045,
    transform: "translate(6415.358 5133.94)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeDasharray: "1.288px, 15.021px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.57px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_386",
    "data-name": "Line 386",
    className: "cls-24",
    x2: 33.045,
    transform: "translate(6415.358 5145.258)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeDasharray: "1.288px, 15.021px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.57px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_387",
    "data-name": "Line 387",
    className: "cls-24",
    x2: 33.045,
    transform: "translate(6415.358 5156.577)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeDasharray: "1.288px, 15.021px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.57px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_388",
    "data-name": "Line 388",
    className: "cls-24",
    x2: 33.045,
    transform: "translate(6415.358 5167.895)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeDasharray: "1.288px, 15.021px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.57px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2914",
    "data-name": "Path 2914",
    className: "cls-22",
    d: "M6439.223,5205.047v-23.292h-15.255v23.292",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.57px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2915",
    "data-name": "Path 2915",
    className: "cls-22",
    d: "M6401.333,5133.94h-40.722v71.107",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.57px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_389",
    "data-name": "Line 389",
    className: "cls-24",
    x1: 18.569,
    transform: "translate(6371.403 5145.258)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeDasharray: "1.288px, 15.021px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.57px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_390",
    "data-name": "Line 390",
    className: "cls-24",
    x1: 18.569,
    transform: "translate(6371.403 5156.577)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeDasharray: "1.288px, 15.021px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.57px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_391",
    "data-name": "Line 391",
    className: "cls-24",
    x1: 18.569,
    transform: "translate(6371.403 5167.895)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeDasharray: "1.288px, 15.021px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.57px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_392",
    "data-name": "Line 392",
    className: "cls-24",
    x1: 18.569,
    transform: "translate(6371.403 5179.213)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeDasharray: "1.288px, 15.021px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.57px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_393",
    "data-name": "Line 393",
    className: "cls-24",
    x1: 18.569,
    transform: "translate(6371.403 5190.532)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeDasharray: "1.288px, 15.021px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.57px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_394",
    "data-name": "Line 394",
    className: "cls-22",
    x2: 171.973,
    transform: "translate(6345.606 5205.047)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.57px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2916",
    "data-name": "Path 2916",
    className: "cls-21",
    d: "M6447.59,5051.977h-12.054l-23.437,23.438h12.054Z",
    transform: "translate(-5348.96 -4360.657)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_395",
    "data-name": "Line 395",
    className: "cls-21",
    x2: 12.054,
    transform: "translate(1078.541 699.355)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_396",
    "data-name": "Line 396",
    className: "cls-25",
    x2: 12.054,
    transform: "translate(1070.505 707.391)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_399",
    "data-name": "Line 399",
    className: "cls-22",
    y1: 16.459,
    transform: "translate(1083.505 707.216)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.57px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2918",
    "data-name": "Path 2918",
    className: "cls-22",
    d: "M6414.984,5095.8v-10.487h33.769V5095.8",
    transform: "translate(-5348.96 -4360.657)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.57px"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategories2);
export default __webpack_public_path__ + "static/media/categories2.1b4d41d7cb4f5bd6e782892614f12890.svg";
export { ForwardRef as ReactComponent };